import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TourIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg width={width || 64.5} height={height || 64.5} viewBox="0 0 64.5 64.5">
      <g transform="translate(.25 .4) translate(0 -.15)">
        <path
          data-name="Path 677"
          d="M11.7 59.744a1.063 1.063 0 00.83-.4c.447-.553 10.874-13.637 10.874-19.817A11.702 11.702 0 000 39.525c0 6.18 10.427 19.258 10.874 19.817a1.063 1.063 0 00.826.402zm0-29.792a9.586 9.586 0 019.58 9.573c0 4.128-6.289 13.155-9.576 17.427-3.286-4.27-9.576-13.3-9.576-17.427a9.586 9.586 0 019.572-9.572zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 10130"
          d="M11.7 210.128a9.586 9.586 0 019.58 9.572c0 4.128-6.289 13.155-9.576 17.427-3.286-4.27-9.576-13.3-9.576-17.427a9.586 9.586 0 019.572-9.572zm0 0"
          transform="translate(0 -180.175)"
          fill="#fee0c0"
        />
        <path
          data-name="Path 10131"
          d="M9.542 210.128a7.423 7.423 0 017.415 7.415c0 3.2-4.87 10.186-7.415 13.494C7 227.729 2.128 220.74 2.128 217.542a7.423 7.423 0 017.414-7.414zm0 0"
          transform="translate(46 -209.081)"
          fill="#fee0c0"
        />
        <circle
          data-name="Ellipse 161"
          cx={3}
          cy={3}
          r={3}
          transform="translate(8 35)"
          fill="#fff"
        />
        <circle
          data-name="Ellipse 162"
          cx={2}
          cy={2}
          r={2}
          transform="translate(53 5)"
          fill="#fff"
        />
        <path
          data-name="Path 678"
          d="M15.96 38.403a4.256 4.256 0 10-4.256 4.256 4.256 4.256 0 004.256-4.256zm-6.384 0a2.128 2.128 0 112.128 2.128 2.128 2.128 0 01-2.128-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 679"
          d="M55.488 22.344a1.062 1.062 0 00.806-.37c.79-.916 7.706-9.08 7.706-13.461a8.512 8.512 0 10-17.024 0c0 4.382 6.916 12.545 7.706 13.461a1.062 1.062 0 00.806.37zm0-20.216a6.39 6.39 0 016.388 6.384c0 2.7-4.062 8.252-6.384 11.107-2.323-2.855-6.384-8.405-6.384-11.107a6.39 6.39 0 016.38-6.384zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 680"
          d="M58.68 7.448a3.192 3.192 0 10-3.192 3.192 3.192 3.192 0 003.192-3.192zm-4.256 0a1.064 1.064 0 111.064 1.064 1.064 1.064 0 01-1.064-1.064zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 681"
          d="M54.424 26.663h1.064a1.064 1.064 0 000-2.128h-1.064a1.064 1.064 0 000 2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 682"
          d="M40.538 33.064h2.151a1.064 1.064 0 100-2.128h-2.168A1.057 1.057 0 0039.466 32a1.071 1.071 0 001.072 1.064zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 683"
          d="M52.521 32a1.064 1.064 0 001.064 1.064h2.167a1.064 1.064 0 100-2.128h-2.167A1.064 1.064 0 0052.521 32zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 684"
          d="M47.886 26.663h2.168a1.064 1.064 0 000-2.128h-2.168a1.064 1.064 0 000 2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 685"
          d="M19.424 61.872h-2.168a1.064 1.064 0 000 2.128h2.168a1.064 1.064 0 000-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 686"
          d="M37.401 30.522a1.043 1.043 0 00.22-.023 1.064 1.064 0 00.822-1.259 2.212 2.212 0 01-.046-.442 2.127 2.127 0 01.232-.968 1.066 1.066 0 00-1.9-.965 4.256 4.256 0 00-.371 2.809 1.065 1.065 0 001.043.848zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 687"
          d="M47.046 33.064h2.168a1.064 1.064 0 100-2.128h-2.168a1.064 1.064 0 100 2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 688"
          d="M41.363 26.663h2.169a1.064 1.064 0 000-2.128h-2.169a1.064 1.064 0 000 2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 689"
          d="M30.82 45.199a1.03 1.03 0 00.258.032 1.065 1.065 0 001.031-.807 3.755 3.755 0 01.758-1.49 1.064 1.064 0 10-1.624-1.368 5.861 5.861 0 00-1.194 2.341 1.064 1.064 0 00.775 1.292zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 690"
          d="M51.892 61.827a5.186 5.186 0 01-.689.045h-1.339a1.064 1.064 0 000 2.128h1.339a7.469 7.469 0 00.957-.062 1.064 1.064 0 10-.272-2.111zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 691"
          d="M53.377 49.391a7.446 7.446 0 00-2.172-.319h-.279a1.064 1.064 0 100 2.128h.279a5.364 5.364 0 011.552.23 1.042 1.042 0 00.31.047 1.064 1.064 0 00.31-2.082zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 692"
          d="M51.102 41.598a1.064 1.064 0 000-2.128h-2.167a1.064 1.064 0 000 2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 693"
          d="M57.493 58.2a1.064 1.064 0 00-1.406.532 5.309 5.309 0 01-1.005 1.49 1.064 1.064 0 101.537 1.47 7.413 7.413 0 001.409-2.086 1.064 1.064 0 00-.535-1.406zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 694"
          d="M63.065 36.46a1.064 1.064 0 00-1.323.72 3.227 3.227 0 01-.831 1.377 1.065 1.065 0 101.49 1.522 5.347 5.347 0 001.383-2.3 1.064 1.064 0 00-.719-1.323zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 695"
          d="M61.851 34.481a1.064 1.064 0 00.793-1.775 5.353 5.353 0 00-2.234-1.481 1.064 1.064 0 10-.691 2.013 3.19 3.19 0 011.34.889 1.066 1.066 0 00.792.354zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 696"
          d="M46.573 49.071h-2.167a1.064 1.064 0 000 2.128h2.167a1.064 1.064 0 000-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 697"
          d="M57.643 39.47h-2.168a1.064 1.064 0 100 2.128h2.168a1.064 1.064 0 100-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 698"
          d="M25.945 61.872h-2.167a1.064 1.064 0 100 2.128h2.167a1.064 1.064 0 100-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 699"
          d="M57.396 52.371a1.066 1.066 0 00-1.76 1.2 5.262 5.262 0 01.745 1.633 1.064 1.064 0 102.059-.532 7.388 7.388 0 00-1.044-2.301zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 700"
          d="M34.08 48.687a3.785 3.785 0 01-1.3-1.059 1.064 1.064 0 00-1.681 1.306 5.9 5.9 0 002.034 1.661 1.064 1.064 0 00.942-1.908zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 701"
          d="M32.467 61.872h-2.171a1.064 1.064 0 000 2.128h2.171a1.064 1.064 0 000-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 702"
          d="M45.51 61.872h-2.163a1.064 1.064 0 100 2.128h2.167a1.064 1.064 0 000-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 703"
          d="M38.061 41.598a1.064 1.064 0 000-2.128h-2.167a1.064 1.064 0 100 2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 704"
          d="M44.587 41.598a1.064 1.064 0 000-2.128h-2.173a1.064 1.064 0 000 2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 705"
          d="M40.052 49.071h-2.168a1.064 1.064 0 100 2.128h2.168a1.064 1.064 0 100-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 706"
          d="M38.989 61.872H36.82a1.064 1.064 0 000 2.128h2.169a1.064 1.064 0 000-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
        <path
          data-name="Path 707"
          d="M12.796 61.872h-1.064a1.064 1.064 0 000 2.128h1.064a1.064 1.064 0 000-2.128zm0 0"
          fill={color || "#fb972e"}
          stroke={color || "#fb972e"}
          strokeWidth={0.5}
        />
      </g>
    </svg>
  );
}
